import { supabase } from "@/shared/integrations/supabase/client";

export type VinculoTipoCorreio =
  | "judicial"
  | "administrativo"
  | "extrajudicial"
  | "procedimento"
  | "instituicao"
  | "cliente";

export function hrefProcessoVinculo(tipo: string | null | undefined, id: string | null | undefined): string | null {
  if (!tipo || !id) return null;
  if (tipo === "judicial") return `/dashboard/juridica/processos/${id}/andamentos`;
  if (tipo === "administrativo") return `/dashboard/juridica/processos-adm/${id}`;
  if (tipo === "extrajudicial") return `/dashboard/juridica/processos-ext/${id}`;
  if (tipo === "procedimento") return `/dashboard/juridica/procedimentos/${id}`;
  if (tipo === "instituicao") return `/dashboard/institutions/${id}`;
  if (tipo === "cliente") return `/dashboard/juridica/processos?clientId=${encodeURIComponent(id)}`;
  return null;
}

export function corBadgeVinculo(tipo: string | null | undefined): {
  bg: string;
  text: string;
  border: string;
} {
  switch (tipo) {
    case "judicial":
      return { bg: "bg-[#791614]/10", text: "text-[#791614]", border: "border-[#791614]/20" };
    case "administrativo":
      return { bg: "bg-[#d7b369]/15", text: "text-[#5c4a22]", border: "border-[#d7b369]/35" };
    case "extrajudicial":
      return { bg: "bg-blue-500/10", text: "text-blue-700", border: "border-blue-500/25" };
    case "procedimento":
      return { bg: "bg-purple-500/10", text: "text-purple-700", border: "border-purple-500/25" };
    case "instituicao":
      return { bg: "bg-[#f9f6f0]", text: "text-[#555]", border: "border-[#a9abae]/30" };
    default:
      return { bg: "bg-[#f9f6f0]", text: "text-[#555]", border: "border-[#a9abae]/30" };
  }
}

export async function fetchLabelProcessoVinculo(
  tipo: string | null | undefined,
  id: string | null | undefined
): Promise<string | null> {
  if (!tipo || !id) return null;
  try {
    if (tipo === "judicial") {
      const { data, error } = await supabase
        .from("processos")
        .select("id, numero_processo, titulo")
        .eq("id", id)
        .maybeSingle();
      if (error || !data) return null;
      return `${data.numero_processo || "—"} · ${(data.titulo || "").slice(0, 56)}`;
    }
    if (tipo === "administrativo") {
      const { data, error } = await supabase
        .from("processos_administrativos")
        .select("id, numero, titulo")
        .eq("id", id)
        .maybeSingle();
      if (error || !data) return null;
      return `${data.numero || "—"} · ${(data.titulo || "").slice(0, 56)}`;
    }
    if (tipo === "extrajudicial") {
      const { data, error } = await supabase
        .from("processos_extrajudiciais")
        .select("id, numero, titulo")
        .eq("id", id)
        .maybeSingle();
      if (error || !data) return null;
      return `${data.numero || "—"} · ${(data.titulo || "").slice(0, 56)}`;
    }
    if (tipo === "procedimento") {
      const { data, error } = await supabase
        .from("procedimentos")
        .select("id, titulo, tipo")
        .eq("id", id)
        .maybeSingle();
      if (error || !data) return null;
      return `${data.titulo || "—"}${data.tipo ? ` (${data.tipo})` : ""}`.slice(0, 80);
    }
  } catch {
    return null;
  }
  return null;
}

const VINCULO_SHORT: Record<string, string> = {
  judicial: "Judicial",
  administrativo: "Adm.",
  extrajudicial: "Extrajudicial",
  procedimento: "Procedimento",
  instituicao: "Instituição",
  cliente: "Cliente",
};

export function labelTipoVinculo(tipo: string | null | undefined): string {
  if (!tipo) return "Processo";
  return VINCULO_SHORT[tipo] || tipo;
}
